module.exports = __webpack_public_path__ + "media/scholarship_winners/emily-c-14b7a0b4.png";